import { render } from "./Statistics.vue?vue&type=template&id=5f2cdd6a"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"
script.render = render

export default script